import { useLanguage } from '../contexts/LanguageContext';
import { Button } from './ui/button';
import { Globe } from 'lucide-react';

const LanguageToggle = () => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={toggleLanguage}
      className="flex items-center gap-2"
      data-testid="language-toggle"
    >
      <Globe className="h-4 w-4" />
      <span className="font-semibold">{language === 'ru' ? 'RU' : 'EN'}</span>
    </Button>
  );
};

export default LanguageToggle;
